export default "__VITE_ASSET__DDPA8E0J__"